export default __webpack_public_path__ + "static/benefitSection1Bg-228441ea04b0ef3db8db858873c537b2.png";